"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolbarBasicFilter = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@veeam/core");
const BasicFilter_1 = require("../../BasicFilter");
function parseValue(value) {
    if (!value || !Array.isArray(value)) {
        return [];
    }
    return value;
}
function toolbarBasicFilter({ title, property, groupId = '', operation = core_1.FILTER_OPERATION.in, collation = core_1.FILTER_COLLATION.ignorecase, items, decorators, disabled, textAllButton, hasAllButton }) {
    return {
        disabled,
        decorators,
        render: (model, { disabled }) => {
            return (react_1.default.createElement(core_1.ModelRenderer, { model: model, render: ({ value }) => (react_1.default.createElement(BasicFilter_1.BasicFilter, { label: title.replace(/:$/, ''), value: parseValue(value.filters.getFilterValue({ property, groupId })), hasAllButton: hasAllButton, textAllButton: textAllButton, onChange: (value) => {
                        model.setFilter({ property, groupId }, {
                            operation,
                            collation,
                            value: value || []
                        });
                    }, disabled: disabled, buttons: items })) }));
        }
    };
}
exports.toolbarBasicFilter = toolbarBasicFilter;
//# sourceMappingURL=toolbarBasicFilter.js.map